import { useState } from 'react';
import './ForgotPasswordChangeForm.scss';

function getPasswordConstraints(password) {
  return {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}<>_\-\\[\]`~;'=+]/.test(password),
  };
}


export default function ForgotPasswordChangeForm({
  userId,
  resetToken,
  onSubmit,
}) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const constraints = getPasswordConstraints(newPassword);
  const passwordsMatch =
    confirmPassword.length === 0 || newPassword === confirmPassword;

  const isPasswordStrong =
    constraints.length &&
    constraints.upper &&
    constraints.lower &&
    constraints.number &&
    constraints.special;

  function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (!isPasswordStrong) {
      setError('Password does not meet all requirements.');
      return;
    }

    onSubmit({
      userId,
      token: resetToken,
      newPassword,
    });
  }

  return (
    <div className="password-change-form-wrapper">
      <form className="password-change-form" onSubmit={handleSubmit}>
        <h4>Set New Password</h4>

        <label>
          New Password
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </label>

        <ul className="password-constraints">
          <li className={constraints.length ? 'met' : 'unmet'}>At least 8 characters</li>
          <li className={constraints.upper ? 'met' : 'unmet'}>One uppercase letter</li>
          <li className={constraints.lower ? 'met' : 'unmet'}>One lowercase letter</li>
          <li className={constraints.number ? 'met' : 'unmet'}>One number</li>
          <li className={constraints.special ? 'met' : 'unmet'}>One special character</li>
        </ul>

        <label>
          Confirm Password
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </label>

        {!passwordsMatch && <p className="error">Passwords do not match.</p>}

        {error && <p className="error">{error}</p>}

        <button
          type="submit"
          disabled={
            !isPasswordStrong ||
            !passwordsMatch ||
            !newPassword ||
            !confirmPassword
          }
        >
          Update Password
        </button>
      </form>
    </div>
  );
}